import { EventEmitter, Injectable } from '@angular/core';
import { Iconable } from './@shared/models/iconable.model';
import { MarcheAPIService } from './@core/api/marche-api.service';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    static readonly NAV_API = '/navigation';
    navigationData: Array<Iconable> = [];
    filters = {};
    showNavigation = false;
    showCategory = false;
    navDataEvent: EventEmitter<any> = new EventEmitter<any>();
    navVisibilityEvent: EventEmitter<any> = new EventEmitter<boolean>();
    categoryVisibilityEvent: EventEmitter<any> = new EventEmitter<boolean>();

    constructor() {}

    // setNavPageData(filters = {}) {
    //     this.marcheAPIService
    //         .getRequest<ResponseWrapper<Array<Iconable>>|null>(
    //             AppService.NAV_API,
    //             filters
    //         )
    //         .subscribe(res => {
    //             if (res.success) {
    //                 this.navigationData = res.data;
    //                 this.navDataEvent.emit(this.navigationData);
    //             } else {
    //                 //  this.errors = res.error;
    //             }
    //         });
    // }

    // setNavigationVisibility(value: boolean) {
    //     this.showNavigation = value;
    //     this.navVisibilityEvent.emit(value);
    // }

    setCategoryVisible(value: boolean) {
        this.showCategory = value;
        this.categoryVisibilityEvent.emit(value);
    }
}
